import React from "react";
import "../../css/toastView.css";
import Heading from "../../components/Heading";
import ContentPage from "../../components/content-page";
import Meta from "../../components/meta";
import PropTypes from "prop-types";
import ReactPixel from "react-facebook-pixel";
import Link from "gatsby-link";
import Modal from "../../components/Modal";
import Slider from "react-slick";
import "../../components/slick.css";
import "../../components/slick-theme.css";
import LinkedInTag from "react-linkedin-insight";
const icon1 = "https://winpeforum.com/assets/elements/AnshulJain.png";
const icon2 = "https://winpeforum.com/assets/elements/KarishmaMakhija.png";
const icon3 = "https://winpeforum.com/assets/elements/HarshaMundhada.png";
const icon5 = "https://winpeforum.com/assets/elements/SaloniJhaveri.png";
const icon6 = "https://winpeforum.com/assets/elements/ShivaniBhasin.png";
const icon4 = "https://winpeforum.com/assets/elements/RemaSubramanian.jpg";
const icon7 = "https://winpeforum.com/assets/elements/GautamMago.png";
const icon8 = "https://winpeforum.com/assets/elements/Lizzie.png";
const icon9 = "https://winpeforum.com/assets/elements/RuchiKhajanchi.png";
let duration = 400;
 

const I1 = "https://www.winpeforum.com/assets/sheshines/06nov2025/1.jpg";
const I2 = "https://www.winpeforum.com/assets/sheshines/06nov2025/2.jpg";
const I3 = "https://www.winpeforum.com/assets/sheshines/06nov2025/3.jpg";
const I4 = "https://www.winpeforum.com/assets/sheshines/06nov2025/4.jpg";
const I5 = "https://www.winpeforum.com/assets/sheshines/06nov2025/5.jpg";
const I6 = "https://www.winpeforum.com/assets/sheshines/06nov2025/6.jpg";
const I7 = "https://www.winpeforum.com/assets/sheshines/06nov2025/7.jpg";
const I8 = "https://www.winpeforum.com/assets/sheshines/06nov2025/8.jpg";
const I9 = "https://www.winpeforum.com/assets/sheshines/06nov2025/9.jpg";
const I10 = "https://www.winpeforum.com/assets/sheshines/06nov2025/10.jpg";
const I11 = "https://www.winpeforum.com/assets/sheshines/06nov2025/11.jpg";
const I12 = "https://www.winpeforum.com/assets/sheshines/06nov2025/12.jpg"; 
 
 
 
 

const II1 = "https://www.winpeforum.com/download.php?file=assets/sheshines/06nov2025/1.jpg";
const II2 = "https://www.winpeforum.com/download.php?file=assets/sheshines/06nov2025/2.jpg";
const II3 = "https://www.winpeforum.com/download.php?file=assets/sheshines/06nov2025/3.jpg";
const II4 = "https://www.winpeforum.com/download.php?file=assets/sheshines/06nov2025/4.jpg";
const II5 = "https://www.winpeforum.com/download.php?file=assets/sheshines/06nov2025/5.jpg";
const II6 = "https://www.winpeforum.com/download.php?file=assets/sheshines/06nov2025/6.jpg";
const II7 = "https://www.winpeforum.com/download.php?file=assets/sheshines/06nov2025/7.jpg";
const II8 = "https://www.winpeforum.com/download.php?file=assets/sheshines/06nov2025/8.jpg";
const II9 = "https://www.winpeforum.com/download.php?file=assets/sheshines/06nov2025/9.jpg";
const II10 = "https://www.winpeforum.com/download.php?file=assets/sheshines/06nov2025/10.jpg";
const II11 = "https://www.winpeforum.com/download.php?file=assets/sheshines/06nov2025/11.jpg";
const II12 = "https://www.winpeforum.com/download.php?file=assets/sheshines/06nov2025/12.jpg"; 
 

const TeamModal = ({ activeItem, show, onHide }) => {
  return (
    <Modal
      direction=""
      className="teamdetails__wrapper"
      show={show}
      onHide={onHide}
    >
      <Modal.Header>
        <div className="head_section">
          <span className="item_name">{activeItem.name}</span>
          <div
            className="item_des"
            dangerouslySetInnerHTML={{ __html: activeItem.post }}
          ></div>
        </div>
        <span className="cross pull-right">
          <i onClick={onHide} className="fa fa-times" />
        </span>
      </Modal.Header>
      <Modal.Body>
        <div className="item__desc">
          <div dangerouslySetInnerHTML={{ __html: activeItem.desc }}></div>
        </div>
      </Modal.Body>
      <Modal.Footer />
    </Modal>
  );
};

TeamModal.propTypes = {
  activeItem: PropTypes.object,
  show: PropTypes.object,
  onHide: PropTypes.object,
};

export class SheShines extends React.Component {
  constructor(args) {
    super(args);
    this.state = {
      slidesToShow: 1,
      activeItem: {},
      isShow: false,
      defaultStyle: {
        transition: `opacity ${duration}ms ease-in-out`,
        opacity: 0,
      },
    };
     
    this.Speaker1 = [
    {
          imgUrl: icon1,
          desc: `<div>
          Anshul is a Managing Director and co-leads the investment team at Lighthouse Funds. She serves on the board of Duroflex. She was previously an investment banker with ICICI Securities.
          <br/><Br/>
          Anshul holds an MBA from Indian Institute of Management (IIM) Indore.
          
              </div>`,
          name: "Anshul Jain",
          post: `<div>Managing Director<br/>
          Lighthouse Funds
          
          </div>`,
        },
         {
          imgUrl: icon7,
          desc: `<div>
         Gautam is a founder and General Partner at A91 Partners; A91 is a growth investment firm founded in 2018 and has made ~30 investments so far. Previously, Gautam was a Managing Director at Sequoia Capital India and also worked at McKinsey & Company. He is an alumnus of IIM Calcutta and the University of Mumbai. He currently serves on the boards of Exotel, IntrCity, Inshorts, Kaar Technologies and Ummeed Housing Finance.

              </div>`,
          name: "Gautam Mago",
          post: `<div>Founder and General Partner<br/>
        A91 Partners

          </div>`,
        },
            {
            imgUrl: icon3,
            desc: `<div>
    Harsha has been a member of the Inflexor team since inception. She handles multiple responsibilities in the fund ranging from handling investor relations, managing deal execution & portfolio management to dealing with the various legal aspects of investing. As a Partner in the firm, she plays a pivotal role in the strategic as well as day to day operations of the firm.
<br/><br/>
Prior to joining Inflexor, Harsha has close to a decade of experience handling financial due diligence in M&A transactions across the Big4 firms like EY, PwC and Deloitte. Her keen insight into financial performance of companies gives her the unique ability to evaluate transactions.  
<br/><br/>
She has a dual distinction of being a rank holder during her CA as well as MBA from IIM Ahmedabad. She is an active member of the Women in Investing communities in Mumbai. She enjoys spending time with her family, has interest in spirituality, early childhood education and collecting handloom sarees from various parts of India.
 </div>`,
            name: "Harsha Mundhadai",
            post: `<div>Partner<br/> Inflexor
 
            </div>`,
          },
 {
            imgUrl: icon2,
           desc: `<div>
      Karishma joined MOPE in 2021. She is responsible for transaction evaluation, financial analysis, deal documentation and portfolio management.
<br/><br/>
Prior to joining Motilal Oswal Private Equity, Ms. Makhija had over 11 years of experience in Investment Banking (Spark Capital, IIFL, HDFC Bank & KPMG) across Private equity, M&A & Capital Market fund raises. During her career, she has successfully executed transactions, some of the notable ones include private equity transactions in TransUnion CIBIL, India Shelter Finance and EssKay Finance, acquisition of Micro Housing Finance by Svatantra Microfinance & IPO of AU Financiers.
<br/><br/>
Ms. Makhija holds a Bachelor's Degree in Commerce from NM College of Commerce and Economics, Mumbai and is a member of the Institute of Chartered Accountants of India.


  
        
        </div>`,
        name: "Karishma Makhija",
        post: `<div>Director - Investments<br/>Motilal Oswal Alternates

         
        </div>`,
          },

       {
            imgUrl: icon8,
           desc: `<div>
      Lizzie is a fintech leader and serial entrepreneur with over twenty years’ experience across financial services, technology, and hospitality.
<br/><Br/>

She co-founded ZestMoney, India’s leading digital lending platform and an early innovator of “buy now, pay later,” raising over $120 million in equity and reaching $50 million in annual revenue. Lizzie also co-founded the Digital Lenders Association of India, advised the Government’s Start-up Advisory Council, and served on the National Payments Corporation Innovation Council.
<br/><br/>

She has founded and grown businesses in financial services, SaaS, hospitality, and wellness, holding non-executive director roles at Mahila Money, IndiaMart, and Cloud Nine.
<br/><Br/>

Beyond her commercial work, Lizzie is a passionate marathon runner, wine event organiser, actor, and writer.

        </div>`,
        name: "Lizzie Chapman",
        post: `<div>Fintech Leader and Serial Entrepreneur 

         
        </div>`,
          },

      {
            imgUrl: icon4,
          desc: `<div>
          Rema has 4 decades experience in 0 to 1 and 1 to 10 stages of enterprises, founding a few, investing and in operational roles in others. Her career has been in category creating products and in future forward technology companies. Some of her notable experiences has been digitalization of financial service sector in early 90’s to edtech at the start of internet to digitalization of SMB in late 80’s.  Her experience extended to category creating product lines such as menswear to home water filters. This gave her the experience in forecasting tech use cases before it become mainstream and identifying business opportunities. Her hands on approach to nurture and help these businesses take root has been her main strength. She has helped businesses grow 20X on an average across the companies she has worked with.<br/><br/>
          That also led to Ankur Capital.  The first decade+ of the millennium saw growth of mobile connectivity, highwayisation, retail activity along the newly built highways and a rapidly increasing aspirational population. At the sametime, India was seeing an increasing activity happening in biotech. Both Rema and Ritu strongly believed middle India was going be the next big opportunity with under penetrated sectors such as agtech, health and related sectors to be the next wave.<br/><br/>
          She is a Cost and Management Accountant (AICWA), ICS, PGD in Systems Management. She is an active contributor to theeco-system as a member of the executive council of IVCA and IIC
  
          </div>`,
          name: "Rema Subramanian",
          post: `<div>Managing Partner
          <br/>
          Ankur Capital Fund
  
   
          </div>`,
          }, 

          {
            imgUrl: icon9,
          desc: `<div>
          Ruchi oversees finance, legal, tax, and investor reporting at A91 Partner. She has over 12 years’ of transaction advisory experience at N.A. Shah Associates where she advised clients on several complex assignments including negotiation, vetting of legal documents, coordinating due diligence, tax and regulatory structuring, and transaction closing. She also has experience in fund raising, setting up of PE/VC funds (under SEBI AIF regulations) and has been involved in advising on M&A, business restructuring, cross border structuring, etc. She has worked with clients across various industries including technology, media, real estate, pharmaceuticals, logistics, etc..
<br/><br/>

Ruchi started her career as a Business Leadership Trainee with Hindustan Unilever Limited.
<br/><Br/>

Ruchi is a Chartered Accountant and achieved a 34th all India rank.

  
          </div>`,
          name: "Ruchi Khajanchi",
          post: `<div>Chief Financial Officer<br/> A91 Partners

   
          </div>`,
          }, 
 

         {
            imgUrl: icon5,
            desc: `<div>
     Saloni has over two decades of experience in private equity, mergers and acquisitions, corporate finance, and strategy, having worked in the US and India. In her career, she has successfully negotiated, executed and closed several cross-border and domestic transactions involving mergers, acquisitions, joint ventures, private equity funding and entry-strategy assignments across sectors.
<br/><br/>
Currently based in Mumbai, she joined NIIF in its early days as the Chief of Staff and was instrumental in building several pillars of the institution. She has played a pivotal role in establishing NIIF’s offices, drafting the Governance Framework and Policies and Procedures for all the verticals of the firm, strategising for fund raising, chalking out the recruitment plan among others
<br/><br/>
She currently heads Investor Relations and Partnerships at NIIF and is responsible for fund raising NIIF funds as well as building strong relationships with global investors, key stakeholders including Government of India representatives, global business leaders and Embassies and Consulates around the world. At NIIF, she has been responsible for successfully fundraising from several large, credible and reputed international and domestic investors.
<br/><br/>
Prior to joining NIIF, she was a Partner at SKP Business Consulting where she led a team of 15 in their M&A and Consulting practice. Saloni has also worked with KPMG India and HDFC Private equity. She started her career with Praxair in 1999, based out of their USA office.
<br/><br/>
Saloni holds a Bachelor’s in Commerce and Master’s in Commerce degree from Sydenham College of Commerce and Economics and an MBA from the Pennsylvania State University.

 </div>`,
            name: "Saloni Jhaveri",
            post: `<div>Head - Investor Relations and Partnerships<br/> 
NIIF


            </div>`,
          },
   {
            imgUrl: icon6,
            desc: `<div>
  Shivani Bhasin Sachdeva is the Founder & CEO of India Alternatives, a top-performing mid- market private equity firm investing in transformational themes in India, having over 22 years of global private equity experience in the US and in India. Shivani is considered a trailblazer in the industry as she is one of the first few women private equity founders in the country.
<br/><br/>
Shivani has received multiple accolades and recognition for being one of the top women leaders in Finance in India, “Private Equity Leader of the Year”, at the WinPE Leadership Awards 2024, and the “Women First Award” at the IVCA Alternate Capital Excellence Awards 2025. India Alternatives was recently awarded “Private Equity Firm of the Year”, at the Winpe Leadership Awards 2025.
<br/><br/>
Shivani is a frequent speaker at domestic and international conferences on private equity and has also written numerous articles and spoken at various forums to promote gender equality. India Alternatives is committed to empowering women across its portfolio companies and the broader ecosystem and has undertaken various initiatives to propel women into leadership positions.
<br/><br/>
Shivani received an MBA from the Wharton School, University of Pennsylvania and a B.A. in Economics from Mount Holyoke College (Phi-Beta-Kappa, Magna Cum Laude, Sarah Williston Scholar.)



 </div>`,
            name: "Shivani Bhasin Sachdeva ",
            post: `<div>Founder & CEO<br/> India Alternatives



            </div>`,
          },
      
 

      
    ];

    this.Speaker2 = [
       
      
      {
        imgUrl: icon2,
        desc: `Alka Goel is the Founder of Alkemi Growth Capital LLP, an early stage healthcare and consumer wellness fund. She has led investment in multiple sub-sectors over the last 6 years. Prior to that, Alka was a Partner in McKinsey & Co., New York office, where she primarily served clients in the life science and private equity industry.
<br/><br/>
At McKinsey, she served more than 350 Clients across all major geographies. She completed her business school from Indian Institute of Management, Ahmedabad in 2000 and Bachelor of Economics from Lady Shri Ram College, Delhi University.


         `,
        name: "Alka Goel",
        post: `<div>Founding Partner<br/> Alkemi Growth Capital
        </div>`,
      },

      
    ];
    this.CollegiumsImages = [
        { id:23, ImgSrc: I1, ImgSrc1: II1,},   
        { id:35, ImgSrc: I2, ImgSrc1: II2,},   
        { id:22, ImgSrc: I3, ImgSrc1: II3,},   
        { id:19, ImgSrc: I4, ImgSrc1: II4,},  
        { id:35, ImgSrc: I5, ImgSrc1: II5,},   
        { id:34, ImgSrc: I6, ImgSrc1: II6,},  
        { id:23, ImgSrc: I7, ImgSrc1: II7,},   
        { id:35, ImgSrc: I8, ImgSrc1: II8,},   
        { id:22, ImgSrc: I9, ImgSrc1: II9,},   
        { id:19, ImgSrc: I10, ImgSrc1: II10,},  
        { id:35, ImgSrc: I11, ImgSrc1: II11,},   
        { id:34, ImgSrc: I12, ImgSrc1: II12,},     
    
    ];
  
  }
  componentDidMount() {
    this.updateWindowDimensions();
    window.addEventListener("resize", this.updateWindowDimensions);
    ReactPixel.init("2879175222167037");
    ReactPixel.track("ViewContent", location);
    LinkedInTag.init("2117884");
    LinkedInTag.track("2310748");
    setTimeout(() => {
      this.setState({
        defaultStyle: {
          transition: `opacity ${duration}ms ease-in-out`,
          opacity: 1,
        },
      });
    }, 500);
  }
  componentWillUnmount() {
    window.removeEventListener("resize", this.updateWindowDimensions);
  }

  updateWindowDimensions = () => {
    const { slidesToShow } = this.state;
    // // console.log("width", window.innerWidth)
    if (window.innerWidth <= 768 && window.innerWidth > 500) {
      if (slidesToShow !== 1) {
        this.setState({
          slidesToShow: 1,
        });
      }
    } else if (window.innerWidth <= 500) {
      if (slidesToShow !== 1) {
        this.setState({
          slidesToShow: 1,
        });
      }
    } else {
      if (slidesToShow !== 1) {
        this.setState({
          slidesToShow: 1,
        });
      }
    }
  };
  togglePopUp = (item) => {
    this.setState({
      isShow: !this.state.isShow,
      activeItem: item || {},
    });
  };
  render() {
    const { defaultStyle, isShow, slidesToShow } = this.state;
    const { location } = this.props;
    let settings = {
      dots: false,
      infinite: true,
      speed: 6000,
      autoplay: true,
      slidesToShow: slidesToShow,
      slidesToScroll: slidesToShow,
      autoplaySpeed: 7000,
      arrows: true,
    };
    console.log("render", this.render1, slidesToShow);
    this.render1 = this.render1 + 1;
    return (
      <ContentPage>
        <Meta
          title="sheshines with Winpe"
          image={"https://winpeforum.com/assets/elements/sheshineswebpage1.png"}
          description="Winpe's first in-person networking event for women in investing and entrepreneurship was welcomed with high enthusiasm and energy and demands for more such sessions! "
          location={location}
        />
        <div className="section__content" style={defaultStyle}>
          <div className="toastshine_wrapper">
            <div className="back_event">
              <Link to="/events/">
                <i className="fa fa-arrow-left">Back to Events</i>
              </Link>
            </div>
            <div className="toastshine_section">
              <div className="m_heading">Winpe sheshines | November 6, 2025 @ A91 Partners 
 </div>
              <div className="r_btm"></div>
               
 
              <div className="date_heading">
                <div className="date_heading">
                <span> Up Close with A91 Partners: Building a differentiated investment firm</span> <br/><br/>
                  <span>November 6, 2025 (5:00 - 8:00 PM IST)</span>
                  <br/>
                  <span> <i>A91 Partners Office, Mumbai </i></span>
                </div>
              </div>
              <center><h3>Hosted By:</h3><br/>
               <img src={"https://winpeforum.com/assets/elements/A91_Final.jpeg"} style={{width:'60px'}}/>   <br/><br/>
           
          </center> <br/>     
              
              <div className="top_text" style={{textAlign:'justify'}}>
         An engaging session exploring how to build a differentiated investment firm rooted in clarity of purpose, discipline, and integrity; followed by hosted table discussions where industry-leading senior women shared practical insights with participants investing with purpose, building investor relationships and balancing risks in venture portfolios. These discussions created a dynamic space for women from PEVC to exchange ideas and build meaningful connections. Hosted at the A91 Partners office, the event was a typical sheshines evening - filled with insightful conversations, practical learnings, and meaningful connections

 <br/><br/>
 <h2 class="ignite-ask-me-anything__heading" style={{ fontSize: "30px" }}>Event Highlights</h2>          <div class="r_btm"></div>

The evening started with a discussion with <b>Gautam Mago</b>, Founder and General Partner, A91 Partners and <b>Ruchi Khajanchi</b>, Chief Financial Officer, A91 Partners hosted with loads of wisdom and humor by <b>Lizzie Chapman</b>, Fintech Leader and Serial Entrepreneur. The conversation used A91’s stellar success as a base to delve into how clear vision, thoughtful strategy, and strong values are critical to build a differentiated investment firm and create enduring businesses. Hosted table discussions further enriched the evening, as speakers reflected on what sets seasoned investors apart—underscoring the importance of pattern recognition, conviction, and the courage to back ideas ahead of their time.


<br/> <br/>

    <div className="row"> 
                          

                  <div className="col-md-12">   

                  <h2 class="ignite-ask-me-anything__heading" style={{ fontSize: "30px" }}>Hosted Table Speakers</h2>          <div class="r_btm"></div>
                      
                 
                     
                      <div className="Our_Speakers container">
                                <center>
                                  <div className="Speakers_img" style={{ width: '100%', margin:'0' }}>
                                    <div className="row">
        
                                      {this.Speaker1.map((item, i) => {
                                       if(i<=10) 
                                       {
                                        return (
                                          <div
                                            className="main_speaker_card col-md-4 col-sm-12 col-lg-4"
                                            key={i}
                                          >
                                            <div className="Scardd">
                                              <div
                                                className="s_img"
                                                onClick={() => this.togglePopUp(item)}
                                              >
                                                 <center>  <img
                                                  src={item.imgUrl}
                                                  alt={item.name}
                                                  className="img-responsive"
                                                  style={{ borderRadius: '50%', width: '150px', height: '150px', objectFit: 'cover' }}
                                                />
                                                </center>
                                              </div>
                                              <br />    <div
                                                className="Speakers_name"
                                                dangerouslySetInnerHTML={{ __html: item.name }}
                                              ></div>
                                              <div
                                                className="Speakers_post"
                                                dangerouslySetInnerHTML={{ __html: item.post }}
                                              ></div>
                                            </div>
                                          </div>
                                        );
                                       }
                                       else 
                                       return (
                                          <div
                                            className="main_speaker_card col-md-3 col-sm-12 col-lg-3"
                                            key={i}
                                          >
                                            <div className="Scardd">
                                              <div
                                                className="s_img"
                                                onClick={() => this.togglePopUp(item)}
                                              >
                                                 <center>  <img
                                                  src={item.imgUrl}
                                                  alt={item.name}
                                                  className="img-responsive"
                                                  style={{ borderRadius: '50%', width: '150px', height: '150px', objectFit: 'cover' }}
                                                />
                                                </center>
                                              </div>
                                              <br />    <div
                                                className="Speakers_name"
                                                dangerouslySetInnerHTML={{ __html: item.name }}
                                              ></div>
                                              <div
                                                className="Speakers_post"
                                                dangerouslySetInnerHTML={{ __html: item.post }}
                                              ></div>
                                            </div>
                                          </div>
                                        );
                                      })}
                                    </div>
                                  </div>
        
                                </center>
                              </div>
        </div>
        
                
</div> 



<br/>
 

<br/><br/>
 <h2 class="ignite-ask-me-anything__heading" style={{ fontSize: "30px" }}>Key Takeaways </h2>    
   <div class="r_btm"></div>

<ul>
<li><b>Clarity of Investment Thesis:</b> 
<br/>
A clear investment philosophy, sound judgment, and a deep understanding of founders, enabling disciplined decision-making across sectors.

</li>
 <li><b>Founder-Centric Approach:</b> 
<br/>
Identifying the right founders—those with integrity, initiative, and strong execution capability—as the foundation of every investment.

</li>
<li><b>Long-Term Lens on Risk and Reward:</b> 
<br/>
Investment decisions guided by a long-term perspective, evaluating risk–reward trade-offs thoughtfully rather than chasing short-term trends.

</li>
<li><b>Focus on Profitability and Fundamentals:</b> 
<br/>
Strong unit economics and a clear path to profitability, with emphasis on building enduring businesses grounded in fundamentals, rather than chasing market momentum.

</li>
<li><b>Value of Strategic Support:</b> 
<br/>
Offer operational expertise, mentorship, and access to networks that help companies scale effectively.
</li>

<li><b>Purpose-Driven Investing:</b> 
<br/>
 Embedding purpose—through sustainability, community impact, and ethical governance—has become a key differentiator, attracting talent, investors, and quality opportunities.
</li>
 
 <li><b>Balancing Vision and Discipline:</b> 
<br/>
The art of venture investing lies in balancing bold vision with disciplined risk assessment, focusing on founder quality, adaptability, and market timing. 
</li>

<li><b>Trust, Alignment, and Diversity:</b> 
<br/>
Sustainable success is built on trust and long-term alignment between investors and founders. Diverse, gender-balanced teams enhance decision-making and firm culture, reinforcing these values.
</li>
</ul>
 
 
 
 
 
 <br/>
 
<hr/>

<i>The evening concluded with a sense of inspiration and camaraderie, capturing the spirit of <b>sheshines</b> — a platform for knowledge exchange, leadership conversations, and building meaningful connections within the PE–VC ecosystem.
</i>


 

              </div>
              <br />

              <br />
             

             
              <div className="container">
                    <div>
                      <Heading title="Gallery" />
                    </div>
                    <div className="row">
                      {this.CollegiumsImages.map((item, j) => {
                        return (
                          <div className="col-lg-4 col-md-4 col-sm-6 col-xs-12" style={{padding: '8px'}}>
                            <div className="img_card">
                            <img style={{width:'100%'}} src={item.ImgSrc} alt="Winpe sheshines" />
                            <a href={item.ImgSrc1} > <i style={{color:'white', position:'absolute', left:'20px', top:'20px'}} class="fa fa-2x  fa-download "></i></a> 
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                 <br/>
  <br/> 
    
       
          <br/><br/>
     
            </div>
            <TeamModal
              show={isShow}
              onHide={this.togglePopUp}
              activeItem={this.state.activeItem}
            />
          </div>
        </div>
      </ContentPage>
    );
  }
}

SheShines.propTypes = {
  location: PropTypes.object,
};

export default SheShines;



// WEBPACK FOOTER //
// ./src/pages/sheshines06Nov2025/index.js